import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WorkflowDefinitionDto } from '../models/workflow.model';
import { PagedResult } from './schema-api.service';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class WorkflowService {
      // Combine your base URL with the API route prefix
      private readonly baseUrl = environment.apiUrl;
      private readonly apiUrl = `${this.baseUrl}/api/sys/workflow/inbox`;

      constructor(private http: HttpClient) { }

      // GET: All (Paged)
      getAll(pageIndex: number, pageSize: number, searchTerm?: string): Observable<PagedResult<WorkflowDefinitionDto>> {
            let params = new HttpParams()
                  .set('pageIndex', pageIndex.toString())
                  .set('pageSize', pageSize.toString());

            if (searchTerm) params = params.set('searchTerm', searchTerm);

            return this.http.get<PagedResult<WorkflowDefinitionDto>>(this.apiUrl, { params });
      }

      // GET: Single by ID
      getById(id: string): Observable<WorkflowDefinitionDto> {
            return this.http.get<WorkflowDefinitionDto>(`${this.apiUrl}/${id}`);
      }

      // GET: Master Data for Actions, States, and Roles
      getMasterData():Observable<WorkflowDefinitionDto> {
            return this.http.get<WorkflowDefinitionDto>(`${this.apiUrl}/masters`);
      }
      
      // POST: Create
      save(dto: WorkflowDefinitionDto): Observable<any> {
            // This sends the object as the root JSON: { "id": "...", "orgId": "..." }
            return this.http.post(this.apiUrl, dto);
      }

      // PUT: Update
      update(id: string, dto: WorkflowDefinitionDto): Observable<any> {
            return this.http.put(`${this.apiUrl}/${id}`, dto);
      }

      // DELETE
      delete(id: string): Observable<any> {
            return this.http.delete(`${this.apiUrl}/${id}`);
      }
      
}